const numberToWords = (number) => {
  if (number === 0) return 'nol rupiah';
  
  const ones = ['', 'satu', 'dua', 'tiga', 'empat', 'lima', 'enam', 'tujuh', 'delapan', 'sembilan'];
  const teens = ['sepuluh', 'sebelas', 'dua belas', 'tiga belas', 'empat belas', 'lima belas', 'enam belas', 'tujuh belas', 'delapan belas', 'sembilan belas'];
  const tens = ['', '', 'dua puluh', 'tiga puluh', 'empat puluh', 'lima puluh', 'enam puluh', 'tujuh puluh', 'delapan puluh', 'sembilan puluh'];
  const scales = ['', 'ribu', 'juta', 'milyar', 'triliun'];

  const convertLessThanOneThousand = (num) => {
    if (num === 0) return '';

    if (num < 10) {
      return ones[num];
    }

    if (num < 20) {
      return teens[num - 10];
    }

    if (num < 100) {
      return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + ones[num % 10] : '');
    }

    if (num < 200) {
      return 'seratus' + (num % 100 !== 0 ? ' ' + convertLessThanOneThousand(num % 100) : '');
    }

    return ones[Math.floor(num / 100)] + ' ratus' + (num % 100 !== 0 ? ' ' + convertLessThanOneThousand(num % 100) : '');
  };

  const convert = (num, scaleIndex) => {
    if (num === 0) return '';

    const scale = scales[scaleIndex];
    const current = num % 1000;
    const remaining = Math.floor(num / 1000);

    let result = '';
    
    if (current !== 0) {
      if (current === 1 && scaleIndex === 1) {
        result = 'seribu';
      } else if (current === 1 && scaleIndex === 2) {
        result = 'sejuta';
      } else if (current === 1 && scaleIndex === 3) {
        result = 'semilyar';
      } else if (current === 1 && scaleIndex === 4) {
        result = 'setriliun';
      } else {
        result = convertLessThanOneThousand(current);
        if (scale) {
          result += ' ' + scale;
        }
      }
    }

    if (remaining !== 0) {
      const remainingWords = convert(remaining, scaleIndex + 1);
      if (remainingWords) {
        result = remainingWords + (result ? ' ' + result : '');
      }
    }

    return result;
  };

  // Handle decimal numbers
  const integerPart = Math.floor(number);
  const decimalPart = Math.round((number - integerPart) * 100);

  let result = convert(integerPart, 0);
  
  if (result) {
    result += ' rupiah';
  }

  if (decimalPart > 0) {
    result += ' ' + convertLessThanOneThousand(decimalPart) + ' sen';
  }

  return result;
};

export default numberToWords; 